var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Socials/Spotify"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M47.8932 29.0951C39.6412 24.1945 26.0297 23.7439 18.1521 26.1347C16.8871 26.5187 15.5493 25.8043 15.1661 24.5396C14.7827 23.2737 15.496 21.9369 16.762 21.5523C25.8049 18.8075 40.8374 19.3375 50.3372 24.9767C51.475 25.6523 51.8483 27.1218 51.1739 28.2577C50.499 29.3955 49.0282 29.7705 47.8932 29.0951ZM47.623 36.3536C47.044 37.293 45.8157 37.5877 44.8775 37.0108C37.9978 32.7819 27.5073 31.5569 19.3681 34.0275C18.3126 34.3465 17.1978 33.7513 16.8772 32.6978C16.5592 31.6424 17.1546 30.5296 18.2081 30.2086C27.506 27.3872 39.0647 28.7538 46.9663 33.6096C47.9045 34.1874 48.1998 35.4163 47.623 36.3536ZM44.4905 43.3244C44.0304 44.0789 43.0482 44.3152 42.2965 43.8553C36.2849 40.1812 28.7183 39.3515 19.8072 41.3868C18.9485 41.5837 18.0927 41.0456 17.8968 40.187C17.7001 39.3286 18.2362 38.4726 19.0968 38.2767C28.8484 36.0474 37.2134 37.0069 43.961 41.1301C44.7133 41.5896 44.9502 42.5723 44.4905 43.3244ZM32.75 6.40014C18.6116 6.40014 7.1499 17.8616 7.1499 31.9998C7.1499 46.1396 18.6116 57.6001 32.75 57.6001C46.8887 57.6001 58.3499 46.1396 58.3499 31.9998C58.3499 17.8616 46.8887 6.40014 32.75 6.40014Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/Spotify.d874670eab4beacd75d92a2cd17a28c6.svg";
export { ForwardRef as ReactComponent };